import type { ComponentRuntimeDefinition } from '../../catalog/index.ts';
import { z } from 'zod';
import { componentHardMinimum } from '../shared/sizingProfiles.ts';

const outcomeConfigSchema = z.object({
  status: z.enum(['success', 'warning', 'neutral', 'info']).default('neutral'),
  title: z.string().max(200).default(''),
  description: z.string().max(1000).default(''),
  metrics: z.array(z.object({
    label: z.string().min(1),
    before: z.number().finite().optional(),
    after: z.number().finite().optional(),
    unit: z.string().max(20).optional(),
  }).strict()).max(10).default([]),
}).strict();

export const outcomeDefinition: ComponentRuntimeDefinition = {
  descriptor: {
    key: 'probfun.outcome@1',
    category: 'feedback',
    title: '结果反馈卡',
    description: '用户完成决策或预测后展示结构化反馈（状态+数字+解释）。',
    capabilities: ['feedback-display', 'outcome-card'],
    suitableFor: ['决策反馈', '预测对比', '结果结论'],
    inputs: [],
    outputs: [],
    events: [],
    constraints: ['状态由配置给定，组件不自行计算', '不绑定实时 Dataset'],
    configSchemaId: 'probfun.outcome.config@1',
    configSchema: {
      type: 'object',
      properties: {
        status: { type: 'string', enum: ['success', 'warning', 'neutral', 'info'] },
        title: { type: 'string' },
        description: { type: 'string' },
        metrics: { type: 'array', maxItems: 10, items: { type: 'object', required: ['label'], properties: { label: { type: 'string' }, before: { type: 'number' }, after: { type: 'number' }, unit: { type: 'string' } } } },
      },
      additionalProperties: false,
    },
    defaultConfig: { status: 'neutral', title: '', description: '', metrics: [] },
    examples: [{ status: 'success', title: '决策有效！', description: '增加一个窗口后，平均等待时间显著下降。', metrics: [{ label: '平均等待时间', before: 5.2, after: 2.1, unit: '分钟' }, { label: '排队人数', before: 15, after: 6, unit: '人' }] }],
    notes: ['与 choice/prediction 配套使用。', 'status 由 Agent 配置给定。', 'metrics[].label / title / description 全部来自配置，「排队人数」只是示例文案。'],
    layout: { ...componentHardMinimum('probfun.outcome@1'), maxWidth: 600 },
    runtimeRequirements: [],
    metadata: { layoutHints: { roles: ['summary'], preferredSize: 'small', supportsCompact: true, supportsExpanded: true, canStack: true, priority: 60 } },
  },
  configSchema: outcomeConfigSchema,
  loader: () => import('./OutcomeBlock.vue').then(m => m.default),
};
